import script from "./InputNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./InputNumber.vue?vue&type=script&setup=true&lang=js"

import "./InputNumber.vue?vue&type=style&index=0&id=708af820&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-708af820"]])

export default __exports__